define('_views/Message-Single',[
	'text!_templates/message-single.html'
],
function(
	MessageTemplate
) {

	return Backbone.View.extend({

		template: _.template(MessageTemplate),

		events: {
			'click [data-delete]': 'delete'
		},

		initialize: function(options){
			this.defaults_model = options.defaults_model;

			this.model.on('change', this.render, this);
			this.model.on('destroy', this.remove, this);

		},

		render: function(){

			this.$el.html(
				this.template({
					message  : this.model.toJSON(),
					defaults : this.defaults_model.toJSON(),
					enabled : Backstage.View.Main.data.parent.Cargo.View.Backstage.enabled
				})
			);

			return this;

		},

		delete: function(e){
			e.preventDefault();

			var _this = this;

			parent.window.Cargo.Modal.Confirm({
				message: 'Delete this Update?',
				selector: 'html',
				confirm: function(){
					_this.model.destroy();
				},
				deny: function(){
					return;
				}
			});
			
			
		}

	});

});

